import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const loaderVariants = [
    'circular',
    'linear',
];
export const loaderSizes = [
    'small',
    'large',
];
export const loaderPropTypes = {
    size: PropTypes.oneOf(loaderSizes),
    value: PropTypes.number,
    displayValue: PropTypes.string,
    variant: PropTypes.oneOf(loaderVariants),
    monochrome: PropTypes.bool,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=Loader.types.js.map